import { render, staticRenderFns } from "./MainColumnForm.vue?vue&type=template&id=0a6731ac&"
import script from "./MainColumnForm.vue?vue&type=script&lang=js&"
export * from "./MainColumnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports